import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';

import { getFilesQueryKey } from './getFiles';
import { getFoldersQueryKey } from './getFolders';
import { getRootFilesQueryKey } from './getRootFiles';
import { getTrashQueryKey } from './getTrash';

import { LibraryItemIdsVersionedDTO } from '../types';

const url = `${PREFIX_URL}/library/modify-versioned`;

type MoveFolderResponse = {
  'conflict-results': any[];
  'error-results': any[];
  'success-results': any[];
};
type MoveFolderDTO = {
  parentId: number;
  itemIdsVersioned: LibraryItemIdsVersionedDTO;
};

export const moveFolder = ({
  parentId,
  itemIdsVersioned,
}: MoveFolderDTO): Promise<MoveFolderResponse> => {
  return axios.put(url, { items: itemIdsVersioned, 'parent-id': parentId });
};

type UseMoveFolderOptions = {
  config?: MutationConfig<typeof moveFolder>;
};

export const useMoveFolder = ({ config }: UseMoveFolderOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (response) => {
      if (response['success-results'].length < 1) {
        return;
      }

      queryClient.invalidateQueries({ queryKey: getFilesQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getFoldersQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getTrashQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getRootFilesQueryKey.list });
    },
    mutationFn: (props) => moveFolder(props),
  });
};
